import { makeStyles } from '@griffel/react';

import { coreuiTokens, tokens } from '../../theme/fluent9';
import type { BorderRadiusName } from '../borders';

const useBorderRadiusClassNames = makeStyles<BorderRadiusName>({
  borderRadiusNone: { borderRadius: tokens.borderRadiusNone },
  borderRadiusSmall: { borderRadius: tokens.borderRadiusSmall },
  borderRadiusMedium: { borderRadius: tokens.borderRadiusMedium },
  borderRadiusLarge: { borderRadius: tokens.borderRadiusLarge },
  borderRadiusXLarge: { borderRadius: tokens.borderRadiusXLarge },
  borderRadius2XLarge: { borderRadius: tokens.borderRadius2XLarge },
  borderRadius3XLarge: { borderRadius: tokens.borderRadius3XLarge },
  borderRadius4XLarge: { borderRadius: tokens.borderRadius4XLarge },
  borderRadius5XLarge: { borderRadius: tokens.borderRadius5XLarge },
  borderRadius6XLarge: { borderRadius: tokens.borderRadius6XLarge },
  borderRadiusXXLarge: { borderRadius: coreuiTokens.borderRadiusXXLarge },
  borderRadiusCircular: { borderRadius: tokens.borderRadiusCircular },
});

export const useBorderRadiusClassName = (radius?: BorderRadiusName): string | undefined => {
  const classNames = useBorderRadiusClassNames();

  return radius ? classNames[radius] : undefined;
};
